import { semantic, typography, radius } from '@/shared/theme/tokens';

/**
 * UnsavedBar — sticky warning strip shown when pending changes exist.
 * Replaces the identical UnsavedBanner pattern in UsersTab, ParametersTab, LayersTab.
 *
 * Props:
 *   label    — description text (e.g. "Unsaved role changes")
 *   count    — optional change count shown before label
 *   onSave   — save handler
 *   onDiscard — discard handler
 *   saving   — boolean; disables both buttons and shows "Saving…"
 */
export function UnsavedBar({ label = 'Unsaved changes', count, onSave, onDiscard, saving }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px 16px',
      background: semantic.warningBg,
      border: `1px solid ${semantic.warningBorder}`,
      borderRadius: radius.lg,
      marginBottom: '12px',
      gap: '12px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span
          className="material-symbols-outlined"
          style={{ fontSize: 16, color: semantic.warning }}
        >
          warning
        </span>
        <span style={{
          fontSize: typography.fontSize.sm,
          fontWeight: typography.fontWeight.semibold,
          color: semantic.warning,
          fontFamily: typography.fontFamily.body,
        }}>
          {count != null ? `${count} unsaved change${count !== 1 ? 's' : ''}` : label}
        </span>
      </div>

      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          onClick={onDiscard}
          disabled={saving}
          style={{
            padding: '6px 14px',
            minHeight: '32px',
            borderRadius: radius.md,
            border: `1px solid ${semantic.warningBorderStrong}`,
            background: 'transparent',
            color: semantic.warning,
            fontSize: typography.fontSize.sm,
            fontWeight: typography.fontWeight.medium,
            fontFamily: typography.fontFamily.body,
            cursor: saving ? 'not-allowed' : 'pointer',
            opacity: saving ? 0.5 : 1,
          }}
        >
          Discard
        </button>
        <button
          onClick={onSave}
          disabled={saving}
          style={{
            padding: '6px 14px',
            minHeight: '32px',
            borderRadius: radius.md,
            border: 'none',
            background: semantic.warning,
            color: '#ffffff',
            fontSize: typography.fontSize.sm,
            fontWeight: typography.fontWeight.semibold,
            fontFamily: typography.fontFamily.body,
            cursor: saving ? 'not-allowed' : 'pointer',
            opacity: saving ? 0.7 : 1,
          }}
        >
          {saving ? 'Saving…' : 'Save'}
        </button>
      </div>
    </div>
  );
}
